import { ApexOptions } from "apexcharts";
import { API_URL } from "../../../constant";
import axiosInstance from "../../../utils/axiosConfig";
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { TailSpin } from "react-loader-spinner";
import { useAuth } from "../../../context/auth-context";

const TradePie = () => {
  const { isAuthenticated } = useAuth();
  const [summaryLoader, setSummaryLoader] = useState<boolean>(false);
  const [summary, setSummary] = useState<any>({}); // Change from any[] to any

  useEffect(() => {
    if (!summaryLoader) {
      setSummaryLoader(true);
      axiosInstance
        .get(`${API_URL}api/users/survey/summary`)
        .then((r: any) => {
          // console.log(r?.data?.data?.volumeCategories);
          setSummary(r?.data?.data?.volumeCategories); // summary is now an object
          setSummaryLoader(false);
        })
        .catch((e: any) => {
          console.log(e.response.data.message);
          setSummaryLoader(false);
        });
    }
  }, [isAuthenticated]);
  const chartData = {
    series: [
      summary["Less than $5K"] || 0,
      summary["$5K - $10K"] || 0,
      summary["$10K - $100K"] || 0,
      summary["More than $100K"] || 0,
    ],
    options: {
      chart: {
        type: "donut",
      },
      labels: [
        "Less than $5K",
        "$5K - $10K",
        "$50K - $100k",
        "More than $100k",
      ],
      colors: ["#279DF3", "#60B7F6", "#095B97", "#0B75C2"],
      stroke: {
        width: 0, // This removes the border
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              total: {
                show: true,
                showAlways: true,
                color: "#ffffff",
                fontSize: "20px",
                fontFamily: "Sora, sans-serif",
                fontWeight: 700,
              },
              value: {
                show: true,
                color: "#BEE1FB",
                formatter: (val: string) => `$${val}`,
              },
            },
          },
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              position: "right",
              markers: {
                fillColors: ["#279DF3", "#60B7F6", "#095B97", "#0B75C2"],
              },
            },
          },
        },
      ],
      legend: {
        position: "right",
        markers: {
          fillColors: ["#279DF3", "#60B7F6", "#095B97", "#0B75C2"],
        },
        fontSize: "12px",
        fontFamily: "Manrope, sans-serif",
        fontWeight: 500,
        labels: {
          colors: "#ffffff",
          useSeriesColors: false,
        },
      },
    } as ApexOptions,
  };
  return (
    <div className="w-full ">
      {summaryLoader ? (
        <div className="w-full flex justify-center items-center mt-6">
          <TailSpin color="#0B75C2" height={60} width={50} />
        </div>
      ) : (
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="donut"
          height={300}
        />
      )}
    </div>
  );
};

export default TradePie;
